const initialData = {
  sellerRLookUpId: 91,
  buyFactorRLookUpId: 96,
}
const sendData = {

  mode: "add", // edit
  date: "",
  id: "",

  sellerId: "", // from RlookUp
  sellerName: "", // from RlookUp
  description: "", // max 200 charachters
  factorId: "", // Null or Some Data

  tableData: [
    // {
    //   recordId: "",
    //   particleFactorId: "", // کد فاکتور فروش جز
    //   inventoryId: "", // کد موجودی
    //   storeId: "", // خودم مقدار دهی میکنم
    //   storeName: "",
    //   productId: "",
    //   productName: "",
    //   productGroup: "",
    //   productSize: "",
    //   productColor: "",
    //   price: "",
    //   number: "",
    //   total: "",
    // },
  ]
};
const componentData = {
  currentStoreId: "",
  currentStoreName: "",
  destinationStoreId: "",
  destinationStoreName: "",
}
export const BuyReturnData = {
  sendData,
  componentData,
  initialData,

}